module.exports = __webpack_public_path__ + "static/media/Regist.fa063167.png";